"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useCheckForInternetExplorer = () => {
  const [IE, setIE] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const checkForIE = () => {
      let userAgent = null;
      if (typeof navigator !== "undefined") {
        userAgent = navigator.userAgent;
      }
      // MSIE used to detect old browsers and Trident used to newer ones
      const isInternetExplorer = userAgent.indexOf("MSIE ") > -1 || userAgent.indexOf("Trident/") > -1;
      if (isInternetExplorer === true) {
        setIE(true);
      }
    };
  }, []);
  return {
    IE
  };
};
var _default = useCheckForInternetExplorer;
exports.default = _default;